export default __webpack_public_path__ + "static/media/deleteIcon.bf67d319.svg";